
<div class="container">
    <div class="row justify-content-between">
        <div class="col-lg-5">
            <div class="section-heading">
                <h6>MY PROCESS</h6>
                <h2>Transform your website dreams into a reality in just a few simple steps.</h2>
                <div class="btn-bar mt-4">
                    <a class="px-btn dark" href="#contactus"><span>Get in touch</span> <i class="bi-arrow-right"></i> </a>
                </div>
            </div>
        </div>
        <div class="col-lg-6">
            <div class="feature-box-01">
                <div class="feature-icon">
                    <span><i class="fa fa-chart-bar"></i></span>
                </div>
                <div class="feature-content">
                    <h5>Concept</h5>
                    <p>Say goodbye to the hassle of managing multiple providers and get an all-in-one website solution that covers design, development, and content creation</p>
                    <ul>
                        <li>Reviewing any existing branding</li>
                        <li>Target audience and competitors research</li>
                        <li>Developing a strategy</li>
                    </ul>
                </div>
            </div>
            <div class="feature-box-01">
                <div class="feature-icon">
                    <span><i class="fa fa-paintbrush"></i></span>
                </div>
                <div class="feature-content">
                    <h5>Design</h5>
                    <p>Say goodbye to the hassle of managing multiple providers and get an all-in-one website solution that covers design, development, and content creation</p>
                    <ul>
                        <li>Reviewing any existing branding</li>
                        <li>Target audience and competitors research</li>
                        <li>Developing a strategy</li>
                    </ul>
                </div>
            </div>
            <div class="feature-box-01">
                <div class="feature-icon">
                    <span><i class="fa fa-code-fork"></i></span>
                </div>
                <div class="feature-content">
                    <h5>Development</h5>
                    <p>Say goodbye to the hassle of managing multiple providers and get an all-in-one website solution that covers design, development, and content creation</p>
                    <ul>
                        <li>Reviewing any existing branding</li>
                        <li>Target audience and competitors research</li>
                        <li>Developing a strategy</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

